<template>
    <div class="wrap-input"  ref="langMenu">
        <button class="lang-btn px-2"
                @click="toggleLangSwitch()">
            <span v-if="localeCode == 1033">{{ lbl.register.lang.en }}</span>
            <span v-else-if="localeCode == 1086">{{ lbl.register.lang.my }}</span>
            <span v-else>{{ lbl.register.lang.ch }}</span>
            <img class="mt-1" src="@/assets/icon/ic-arrow-down.svg" alt="" />
        </button>
        <div class="dropdown-lang"
                v-show="showLangSwitch">
            <div class="show-lang">
                <div class="" @click="clickSwitchLang(1033)">
                    {{ lbl.register.lang.en }}
                    <div class="line"></div>
                </div>
                <div class="my-1" @click="clickSwitchLang(1086)">
                    {{ lbl.register.lang.my }}
                    <div class="line"></div>
                </div>
                <div class="mt-1" @click="clickSwitchLang(2052)">
                    {{ lbl.register.lang.ch }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Locale from '@/helper/locale/locale.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: "SwitchLang",
    mixins: [LocaleMixin],
    data: function() {
        return {
            localeCode: Locale.getLocaleCode(),
            showLangSwitch: false,
            langMenu: null
        };
    },
    methods: {
        toggleLangSwitch: function() {
            if (this.showLangSwitch) {
                this.closeLangMenu();
            } else {
                this.openLangMenu();
            }
        },
        openLangMenu: function() {
            this.showLangSwitch = true;
        },
        closeLangMenu: function() {
            this.showLangSwitch = false;
        },
        clickSwitchLang: function(locale) {
            if (this.localeCode == locale) return
            this.showLangSwitch = false;
            this.switchLang(locale);
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.wrap-input {
    position: relative;
    font-size: 0.875rem;
    .lang-btn {
        position: absolute;
        right: 20px;
        top: 20px;
        border: 1px solid white;
        border-radius: 10px;
        background-color: rgba(255, 255, 255, 0);
        color: white;
        min-width: 65px;
        width: fit-content;
        height: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        @media (min-width: $min-width-tablet) {
            right: 6rem;
            min-width: 80px;
            width: fit-content;
        }
    }
    .dropdown-lang {
        position: absolute;
        right: 20px;
        top: 4rem;

        @media (min-width: $min-width-tablet) {
            right: 6rem;
            top: 4rem;
            min-width: 80px;
            width: fit-content;
        }
        .show-lang {
            border: 1px solid white;
            border-radius: 10px;
            background-color: rgba(255, 255, 255, 0);
            color: white;
            min-width: 65px;
            width: fit-content;
            text-align: center;
            padding: 6px 4px;

            @media (min-width: $min-width-tablet) {
                width: fit-content;
                min-width: 80px;
            }
            .line {
                border-bottom: 1px solid white;
                width: 100%;
                padding: 2px;
            }
        }
    }
}
</style>